import { $g } from '../../utils/global';
import { $storage } from '../../utils/storage';
import { $cookie } from '../../utils/cookie';
export const getters = {
    user: (state) => {
        let user = state.user;
        if (!user)
            user = JSON.parse($storage.get($g.caches.storages.user) ?? '{}');
        return user;
    },
    access: (state) => {
        let token = state.token.access;
        if (!token)
            token = $cookie.get($g.caches.cookies.token.access);
        return token;
    },
    refresh: (state) => {
        let token = state.token.refresh;
        if (!token)
            token = $cookie.get($g.caches.cookies.token.refresh);
        return token;
    },
    auto: (state) => {
        let auto = state.auto;
        if (auto === null)
            auto = $cookie.get($g.caches.cookies.auto);
        return auto;
    }
};
